import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { MarkerRepository } from '../application/MarkerRepository'

export function createResilientMarkerRepository(
  primary: MarkerRepository,
  fallback: MarkerRepository,
): MarkerRepository {
  return {
    async list() {
      try {
        return await primary.list()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'markers', operation: 'list', fallback: true })
        return fallback.list()
      }
    },
    async history() {
      try {
        return await primary.history()
      } catch (error) {
        reportUnexpectedError(error, { feature: 'markers', operation: 'history', fallback: true })
        return fallback.history()
      }
    },
    // La liste terrain ne se replie jamais sur des fixtures : de fausses résidences au champ sont pires qu'une erreur.
    listField() {
      return primary.listField()
    },
    // Une écriture ne se replie jamais sur les fixtures.
    complete(command) {
      return primary.complete(command)
    },
    reportFailure(command) {
      return primary.reportFailure(command)
    },
  }
}
